export const blockIconsMapsPlace = (
	<span className='material-symbols-outlined'>place</span>
);
